module.exports = require("assert");


/*****************
 ** WEBPACK FOOTER
 ** external "assert"
 ** module id = 332
 ** module chunks = 0
 **/